<template>
  <div id="users_suplist" class="users_suplist">
    <el-tabs type="border-card">
      <el-tab-pane label="支持记录">
        <el-table
          :data="tableData"
          stripe
          style="width: 100%">
          <el-table-column
            prop="outtradeno"
            label="单号">
          </el-table-column>
          <el-table-column
            prop="totalfee"
            label="金额(分)">
          </el-table-column>
          <el-table-column
            prop="sqlgrid"
            label="插件功能值">
          </el-table-column>
          <el-table-column
            prop="addtime"
            label="时间">
          </el-table-column>
          <el-table-column
            prop="ispay"
            label="状态">
          </el-table-column>
          <el-table-column
            prop="oldgrid"
            label="原插件功能值">
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {allsupport} from 'network/users.js'
export default {
  name:'users_suplist',
  data() {
    return {
      tableData:[],
    }
  },
  props:{
    
  },
  computed: {
    
  },
  components:{
    
  },
  methods: {
    handleClick(item){
      console.log(item);
    }
  },
  created(){
    // console.log(this.$store.state.phone);
    allsupport(this.$store.state.phone).then(res=>{
      // console.log(res);
      if(res.state != 0 && res.code == 4){
        this.$elMessage(res.msg,"error",true)
        return
      }
      for(let i of res.data){
        i.addtime = (new Date(i.addtime)).format("yyyy-M-d h:m:s")
        i.ispay = i.ispay == "Y"?'已支付':'未支付'
      }
      this.tableData = res.data
    }).catch(err=>{
      this.$elMessage('出错',"error",true)
    })
  },
  beforeRouteEnter(to,from,next){
    next(vm=>{
      if(!vm.$store.state.username){
        vm.$router.push('/home')
        vm.$store.state.reg_logVisible = true
      }
    })
  }
}
</script>

<style>
#users_suplist{
  flex: 1;
  overflow-y: scroll;
  background-color: rgb(240, 240, 240);
  padding: 38px 35px 38px;
}
</style>